export const activesave = ({ commit, state }, active) => {
    commit('ACTIVE_SAVE', active)
}
